import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, Typography } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import GCBackButton from "../../components/GreenCity/GCBackButton";
import TextButton from "../../components/GreenCity/TextButton";
import Separator from "../../components/Separator";
import LoadingModal from "../../components/LoadingModal";
import PostCard from "../../components/lists/PostCard";
import LoadMoreButton from "../../components/LoadMoreButton";
import appServices from "../../services/app-services/appServices";
import { createNewPostState } from "../../util/CreatePost"
import { isSubLeaderRole, isGroupLeader } from "../../util/utils";

const AddIcon = () => {
  return (
    <div style={styles.addIcon}>
      <AddRoundedIcon sx={{ width: 20, height: 20 }} />
    </div>
  );
};

function GroupEventSettingPage(): ReactElement {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const { user } = useSelector((state: any) => state.userAuth);

  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [pagination, setPagination] = useState<any>({});

  const getEvents = async (page: number) => {
    if (!page) return

    try {
      setLoading(true);
      const response = await appServices.getGroupEventsPagination(
        groupInfo.id,
        page
      );
      const newItems = [...events, ...response.posts];
      setEvents(newItems);
      setPagination(response.pagination);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEvents(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ paddingTop: 100 }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <LoadingModal visible={loading} handleClose={() => {}} />

      <Box component="div" style={styles.topButtonContainer}>
        <div>
          <Typography style={styles.everyonePostStyle}>{T("event_post")}</Typography>
        </div>
        {(isSubLeaderRole(groupInfo?.role) || isGroupLeader(groupInfo, user)) && (
          <TextButton
            onClick={() =>
              navigate("/createPost", createNewPostState("GroupEventPost", user, groupInfo, [], dispatch))
            }
            Icon={AddIcon}
            title={T("submit_post")}
          />
        )}
      </Box>
      <Separator sx={{ marginTop: "10px" }} color="gray" />
      {events?.map((event: any) => (
        <Box key={event.id}>
          <PostCard
            post={event}
            showEventStatus
          />
        </Box>
      ))}

      <LoadMoreButton show={pagination?.next_page > 0} onClick={() => getEvents(pagination?.next_page)} />
    </div>
  );
}

const styles = {
  container: {
    paddingTop: 90,
  },
  addIcon: {
    border: "2px solid",
    borderRadius: 5,
    borderColor: "#000000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  topButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
    padding: "0 10px",
  },

  everyonePostStyle: {
    fontSize: 16,
  },
};

export default GroupEventSettingPage;
